export class TTLCache {
    ttlMs;
    entries = new Map();
    constructor(ttlMs) {
        this.ttlMs = ttlMs;
    }
    get(key) {
        const entry = this.entries.get(key);
        if (entry && Date.now() < entry.expiresAt)
            return entry.value;
        return undefined;
    }
    set(key, value) {
        this.entries.set(key, { value, expiresAt: Date.now() + this.ttlMs });
    }
}
